import { render, staticRenderFns } from "./SegmentationLimiterDataSelect.vue?vue&type=template&id=8f6f13cc"
import script from "./SegmentationLimiterDataSelect.vue?vue&type=script&lang=js"
export * from "./SegmentationLimiterDataSelect.vue?vue&type=script&lang=js"
import style0 from "./SegmentationLimiterDataSelect.vue?vue&type=style&index=0&id=8f6f13cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports